import { render, staticRenderFns } from "./FieldsetGenderParts.vue?vue&type=template&id=f856daf6&scoped=true"
import script from "./FieldsetGenderParts.vue?vue&type=script&lang=ts"
export * from "./FieldsetGenderParts.vue?vue&type=script&lang=ts"
import style0 from "./FieldsetGenderParts.vue?vue&type=style&index=0&id=f856daf6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f856daf6",
  null
  
)

export default component.exports